module.exports = __webpack_public_path__ + "img/vehicle_home.50b9b501.png";